import { wpFetch } from 'src/helpers/wpApiHandler';

const useGetLeadsBySearch = async ({
  companyId,
  leadSource = -1,
  currentStatus = 'all',
  searchTerm = '',
  page = 0,
  rowsPerPage = 50,
  recruiterId,
  filteredPosition = 'all',
}) => {
  const requestBody = {
    company_id: companyId,
    lead_source: leadSource,
    status: currentStatus,
    search_term: searchTerm,
    leads_per_page: rowsPerPage,
    page: page + 1,
    driver_position: filteredPosition,
    ...(recruiterId ? { recruiter_id: recruiterId } : {}),
  };

  return wpFetch(['allleads'], { method: 'POST', body: requestBody });
};

export default useGetLeadsBySearch;
